export const timeZoneAbbrs = {
  EST: 'ET',
  EDT: 'ET',
  CST: 'CT',
  CDT: 'CT',
  MST: 'MT',
  MDT: 'MT',
  PST: 'PT',
  PDT: 'PT',
  HST: 'HT',
  HDT: 'HT',
}

export const defaultTimezone = 'US/Hawaii'
